
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'admin': `Administración`,
'admin.menu.audit': `Registros de auditoría`,
'admin.menu.directory-auth': `Autenticación de directorio`,
'admin.menu.identity-providers': `Proveedores de identidad y autenticación`,
'admin.menu.ip-allowlist': `Lista de permitidos de IP`,
'admin.menu.organization-settings': `Configuración de la organización`,
'admin.menu.roles': `Roles`,
'admin.menu.scim-tokens': `Tokens SCIM`,
'admin.menu.site-admin': `Administración del sitio`,
'admin.menu.site-admin.create': `Crear sitio`,
'admin.menu.user-groups': `Grupos de usuarios`,
'admin.menu.users': `Administración de usuarios`,
'admin.menu.workload-identities': `Identidades de carga de trabajo`,
'ai-coworkers.menu.agents.deployment': `Implementación`,
'ai-coworkers.menu.agents.events': `Eventos`,
'ai-coworkers.menu.control': `Protección`,
'ai-coworkers.menu.control.exceptions': `Solicitudes de excepción`,
'ai-coworkers.menu.control.policies': `Políticas`,
'ai-coworkers.menu.control.yara-rules': `Reglas YARA`,
'ai-coworkers.menu.dashboards': `Panel`,
'ai-coworkers.menu.intelligence': `Inteligencia`,
'ai-coworkers.menu.intelligence.coding-sessions': `Sesiones de IA`,
'ai-coworkers.menu.inventory': `Visibilidad`,
'ai-coworkers.menu.inventory.agent-skills': `Habilidades de agentes`,
'ai-coworkers.menu.inventory.agents': `Agentes de IA`,
'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
'ai-coworkers.menu.inventory.mcp-servers': `Servidores MCP`,
'ai-coworkers.menu.inventory.model-endpoints': `Endpoints de LLM`,
'ai-coworkers.menu.settings': `Configuración`,
'ai-coworkers.menu.settings.administration': `Administración`,
'ai-coworkers.menu.settings.connectors': `Conectores`,
'ai-coworkers.menu.settings.license': `Licencia y uso`,
'ai-coworkers.menu.settings.update-strategy': `Estrategia de actualización`,
'analytics': `Análisis`,
'appliance': `Dispositivo`,
'auditing': `Auditoría`,
'breadcrumbNavLabel': `Ruta de navegación`,
'breadcrumbOverflowLabel': `Mostrar más elementos de navegación`,
'computer-groups': `Grupos de computadoras`,
'computers': `Computadoras`,
'configuration': `Configuración`,
'dashboard': `Dashboards`,
'downloads': `Consolas y descargas`,
'entitle.menu.accessReview': `Resumen`,
'entitle.menu.auditLogs': `Registros de auditoría`,
'entitle.menu.bundles': `Paquetes`,
'entitle.menu.identityGraph': `Permisos`,
'entitle.menu.integrations': `Integraciones`,
'entitle.menu.policies': `Políticas de derechos innatos`,
'entitle.menu.profile': `Mi configuración`,
'entitle.menu.requests': `Solicitudes`,
'entitle.menu.requestsLog': `Historial de solicitudes`,
'entitle.menu.settings': `Configuración de organización`,
'entitle.menu.tasks': `Tareas`,
'entitle.menu.users': `Usuarios`,
'entitle.menu.workflows': `Flujos de aprobación`,
'epml.menu.audit': `Auditoría`,
'epml.menu.consoleAccess': `Acceso a consola`,
'epml.menu.consoleAudit': `Auditoría de consola`,
'epml.menu.directoryServices': `Servicios de directorio`,
'epml.menu.endpoints': `Administración de endpoints`,
'epml.menu.epmlSettings': `Configuración de EPML`,
'epml.menu.events': `Eventos`,
'epml.menu.explore': `Explorar`,
'epml.menu.installers': `Instaladores`,
'epml.menu.linuxHostAuth': `Autenticación de host Linux`,
'epml.menu.policy': `Política`,
'epml.menu.roles': `Roles`,
'epml.menu.searchAndReplay': `Búsqueda y reproducción`,
'epml.menu.settings': `Configuración`,
'epml.menu.siemConnections': `Conexiones SIEM`,
'epml.menu.unifiedSearch': `Búsqueda unificada`,
'home': `Inicio`,
'insights.menu.accounts': `Cuentas`,
'insights.menu.agentInventory': `Inventario de agentes`,
'insights.menu.aiAgents': `Agentes de IA`,
'insights.menu.aiSecurity': `Seguridad de IA`,
'insights.menu.aiThreatDetection': `Detección de amenazas`,
'insights.menu.aiThreatPolicy': `Política de amenazas`,
'insights.menu.connectors': `Conectores`,
'insights.menu.dashboard': `Dashboard`,
'insights.menu.detections': `Detecciones`,
'insights.menu.entitlements': `Derechos`,
'insights.menu.exclusionRules': `Reglas de exclusión`,
'insights.menu.identities': `Identidades`,
'insights.menu.identitiesPrivileges': `Identidades y privilegios`,
'insights.menu.insights': `Insights`,
'insights.menu.integrations': `Integraciones`,
'insights.menu.integrationsConnections': `Integraciones y conexiones`,
'insights.menu.recommendations': `Recomendaciones`,
'insights.menu.reporting': `Informes`,
'insights.menu.secrets': `Secretos`,
'insights.menu.secretsInventory': `Inventario de secretos`,
'insights.menu.secretsSecurity': `Seguridad de secretos`,
'jit-access-management': `Administración de acceso JIT`,
'jump': `Asset Management`,
'localization': `Localización`,
'login.account_policy.index': `Políticas de cuentas`,
'login.api_account.index': `Configuración de API`,
'login.appliance.index': `Dispositivo`,
'login.business_hours.index': `Horario`,
'login.callback_button.index': `Botones de soporte`,
'login.canned_message.index': `Mensajes predefinidos`,
'login.canned_script.index': `Scripts predefinidos`,
'login.compliance.index': `Cumplimiento`,
'login.custom_fields.index': `Campos personalizados`,
'login.custom_links.index': `Enlaces personalizados`,
'login.customer_notice.index': `Avisos al cliente`,
'login.dashboard.getNetworkRestrictions': `Restricciones de red`,
'login.dashboard.index': `Dashboards`,
'login.discovery.index': `Descubrimiento`,
'login.downloads.drivers.index': `Controladores`,
'login.downloads.rep.index': `Rep Console`,
'login.duplicate_pinned_clients_reporting.index': `Jump Clients duplicados`,
'login.email_settings.index': `Configuración de correo electrónico`,
'login.endpoint_automation.index': `Automatización de endpoints`,
'login.exit_survey.index': `Encuestas de salida`,
'login.file_store.index': `Almacén de archivos`,
'login.group_policy.index': `Políticas de grupo`,
'login.html_template.index': `Plantillas HTML`,
'login.ios_profile.index': `Configuración de iOS`,
'login.issue.index': `Problemas`,
'login.jump_item_reporting.index': `Asset`,
'login.jump_item_roles.index': `Asset Roles`,
'login.jump_item.index': `Assets`,
'login.jump_policies.index': `Asset Policies`,
'login.kerberos_keytab.index': `Kerberos Keytab`,
'login.license_reporting.index': `Licencias`,
'login.licensing.index': `Licencias`,
'login.mcp_config.index': `Servidor MCP`,
'login.ms_teams.index': `MS Teams`,
'login.my_account.profile.index': `Perfil`,
'login.my_account.security.index': `Seguridad`,
'login.nls.real_time_chat.index': `Chat en tiempo real`,
'login.outbound_event.index': `Eventos salientes`,
'login.pinned_clients.index': `Jump Clients`,
'login.public_site.index': `Sitios públicos`,
'login.push_agent.index': `Gateway`,
'login.rep_invite.index': `Invitación de representante`,
'login.rep_profile.index': `Configuración de Rep Console`,
'login.sd_client.index': `Cliente de soporte`,
'login.sd_general.index': `Opciones`,
'login.security_providers.index': `Proveedores de seguridad`,
'login.security_settings.index': `Seguridad`,
'login.session_policy.index': `Políticas de sesión`,
'login.session_report.index': `Soporte`,
'login.settings.index': `Software`,
'login.shared_jump_groups.index': `Asset Groups`,
'login.site_settings.index': `Configuración del sitio`,
'login.skill.index': `Habilidades`,
'login.special_action.index': `Acciones especiales`,
'login.status_representatives.index': `Representantes`,
'login.status.index': `Información`,
'login.support_settings.index': `Soporte`,
'login.syslog_reporting.index': `Syslog`,
'login.team.index': `Equipos de soporte`,
'login.user.index': `Usuarios`,
'login.vault_account_group.index': `Grupos de cuentas`,
'login.vault_account.index': `Cuentas`,
'login.vault_domain.index': `Dominios`,
'login.vault_endpoint.index': `Endpoints`,
'login.vault_options.index': `Opciones`,
'login.vault_password_safe_connection.index': `Conexiones`,
'login.vault_reporting.index': `Bóveda`,
'management': `Administración`,
'management-rules': `Reglas de administración`,
'menu-phantom-labs': `Phantom Labs (es-419)`,
'my_account': `Mi cuenta`,
'pmc.audit': `Auditoría`,
'pmc.explore': `Explorar`,
'pmc.settings': `Configuración`,
'policies': `Políticas`,
'public_site': `Portales públicos`,
'rep_console': `Configuración de consola`,
'reporting': `Informes`,
's352719d86112de9a': `Ayuda`,
's3741f519c32ac391': `Nuevo`,
's3d64ea063be4c9f2': `Auditoría unificada`,
's416434bef0c17abc': `No se pudo cargar el menú. Ciérrelo y vuelva a abrirlo para intentarlo nuevamente.`,
's417b90913e05bc17': `Vista previa`,
's49730f3d5751a433': `Cargando...`,
's4c9351ce0cc28196': `Navegación de productos`,
's596a144afb429d94': `Más productos`,
's5e8250fb85d64c23': `Cerrar`,
's691d6163aaabb69b': `Perfil de usuario`,
's6abb1cd87fe0114e': `Inicio`,
's6d8c02aee480af7a': `Menú`,
's714ea1e6436002a2': `Mantener la navegación anclada`,
's76902262e33e63b5': `Alternar la navegación lateral`,
'sd': `Configuración`,
'sffe2914d4b7c91ee': `Acceso anticipado`,
'sitemenu.about': `Acerca de`,
'sitemenu.analytics': `Análisis e informes`,
'sitemenu.analyticsandreporting.viewallreports': `Ver todos los informes`,
'sitemenu.analyticsandreportingtrident': `Análisis e informes`,
'sitemenu.assets': `Activos`,
'sitemenu.configuration': `Configuración`,
'sitemenu.dashboard': `Dashboard`,
'sitemenu.dashboard.dynamicdashboard': `Dashboard (Vista previa)`,
'sitemenu.discovery': `Descubrimiento`,
'sitemenu.discovery.activeandcompletedscans': `Análisis activos/completados`,
'sitemenu.discovery.discoveryscanners': `Escáneres de descubrimiento`,
'sitemenu.discovery.newdiscoveryscan': `Ejecutar un nuevo análisis de descubrimiento`,
'sitemenu.discovery.scheduledscans': `Análisis programados`,
'sitemenu.managedaccounts': `Cuentas administradas`,
'sitemenu.managedsystems': `Sistemas administrados`,
'sitemenu.passwordsafe': `Password Safe`,
'sitemenu.passwordsafe.accounts': `Cuentas`,
'sitemenu.passwordsafe.activesessions': `Sesiones activas`,
'sitemenu.passwordsafe.administratorsessions': `Sesiones de administrador`,
'sitemenu.passwordsafe.approvals': `Aprobaciones`,
'sitemenu.passwordsafe.completedsessions': `Sesiones completadas`,
'sitemenu.smartrules': `Reglas inteligentes`,
'sitemenu.teampasswords': `Secrets Safe`,
'siteSelectorDataResidency': `residencia de datos`,
'siteSelectorLabel': `Sitio`,
'siteSelectorNoSitesFound': `No se encontraron sitios`,
'siteSelectorSearchPlaceholder': `Buscar sitios`,
'status': `Estado`,
'user-management': `Administración de usuarios`,
'users': `Usuarios y seguridad`,
'vault': `Bóveda`,
    };
  